import React from 'react'
import { TextField, TextFieldProps } from '@mui/material'
import { backgroundColors } from '../Color/Color'

const DisabledTextField: React.FC<Omit<TextFieldProps, 'disabled'>> = (props) => {
  return (
    <TextField
      {...props}
      disabled
      sx={{
        '& .MuiInputBase-input.Mui-disabled': {
          WebkitTextFillColor: `${backgroundColors.greyCharcoal}`,
        },
        '& .MuiInputLabel-root.Mui-disabled': {
          color: backgroundColors.purpleTelus,
        },
        '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
          borderColor: backgroundColors.purpleTelus,
        },
        ...props.sx, // Merge any additional sx props passed to the component
      }}
    />
  )
}

export default DisabledTextField
